import React from 'react';
import SnapshotCardBase from './SnapshotCardBase';

export default function UserSnapshotCard({ data, onOpenDrawer }) {
  return (
    <SnapshotCardBase
      title="Kullanıcı"
      help={{
        description: 'Aktif kullanıcı kitlesinin büyüklüğünü ve kullanıcı tipi dağılımını gösterir.',
        interpretation: 'Aktif kullanıcı artarken ücretli oran sabitse gelir potansiyeli yatay kalabilir.',
        metricExample: 'Aktif kullanıcı artar ama ücretli düşerse teklif katmanı gözden geçirilmeli.'
      }}
      primary={Number(data?.activeUsers || 0).toLocaleString('tr-TR')}
      metrics={[
        { label: 'Ücretli', value: Number((data?.paidUsers ?? data?.premiumUsers) || 0).toLocaleString('tr-TR') },
        { label: 'Deneme', value: Number(data?.trialUsers || 0).toLocaleString('tr-TR') },
        { label: 'Ücretsiz', value: Number(data?.freeUsers || 0).toLocaleString('tr-TR') },
        { label: 'Bebekli', value: Number(data?.babyUsers || 0).toLocaleString('tr-TR') },
        { label: 'Alerjanlı', value: Number(data?.allergyUsers || 0).toLocaleString('tr-TR') }
      ]}
      onOpenDrawer={onOpenDrawer}
    />
  );
}
